<template>
    <div>
        <form v-if="show_inquiry_form" @submit.prevent="getCustomer" id="get_customer_by_code">
            <div class="container p-3 pt-5 my-4 border in-border-header" style="text-align: right">
                <kt-form-section is_first>
                    <div class="section-header">
                        {{ $t('pos.get_customer_by_code') }}
                    </div>
                    <kt-row>
                        <kt-col lg="3" md="3" xs="12">
                            <kt-form-group>
                                <kt-form-label for="customer_type_id">
                                    {{ $t('pos.customer_type') }}<span style="color: red">{{ '*' }}</span>
                                </kt-form-label>
                                <select
                                        id="customer_type_id"
                                        class="form-control kt-selectpicker"
                                        name="customer_type_id"
                                        v-model="inquiry_form.customer_type_id"
                                >
                                    <option
                                            v-for="(user_type, index) in constants.customer_type" :key="user_type"
                                            :value="index">
                                        {{ user_type }}
                                    </option>
                                </select>
                                <div class="my-4">
                                </div>
                            </kt-form-group>
                        </kt-col>
                        <kt-col v-if="inquiry_form.customer_type_id==customerType.REAL ||
                         inquiry_form.customer_type_id==customerType.MULTI_ACCOUNT_OWNER" lg="5" md="6" xs="12">
                            <kt-form-group>

                                <kt-form-label for="national_code">
                                    {{ $t('label.national_code') }}<span style="color: red">{{ ' *' }}</span>
                                </kt-form-label>
                                <kt-form-control
                                        style="text-align: left;text-decoration: solid"
                                        id="national_code"
                                        name="national_code"
                                        v-model="inquiry_form.national_code"
                                        type="number"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col v-if="inquiry_form.customer_type_id==customerType.LEGAL" lg="5" md="6" xs="12">
                            <kt-form-group>
                                <kt-form-label for="company_code">
                                    {{ $t('label.national_legal_code') }}<span style="color: red">{{ '*' }}</span>
                                </kt-form-label>
                                <kt-form-control
                                        style="text-align: left;text-decoration: solid"
                                        id="company_code"
                                        name="company_code"
                                        v-model="inquiry_form.company_code"
                                        type="number"
                                >
                                </kt-form-control>
                            </kt-form-group>
                        </kt-col>
                        <kt-col v-if="inquiry_form.customer_type_id == customerType.REAL ||
                        inquiry_form.customer_type_id==customerType.LEGAL||
                        inquiry_form.customer_type_id==customerType.MULTI_ACCOUNT_OWNER "
                                lg="3" md="3"
                                xs="5">
                            <kt-form-action class="mt-4">
                                <kt-button
                                        class="m-2"
                                        size="md"
                                        variant="success"
                                        type="submit"
                                        v-bind:wide="true"
                                        id="submit_btn"
                                >
                                    {{ $t('pos.btn_inquiry') }}
                                </kt-button>
                            </kt-form-action>
                        </kt-col>
                    </kt-row>
                </kt-form-section>
            </div>
        </form>
        <customer-detail v-if="show_detail" :form_data="form_data"
                         :wizard="wizard"></customer-detail>
    </div>
</template>

<script>
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import {KTApp} from '@/plugins/core/app'
import {posService} from '@/common/api.service'
import customerDetail from "./customer-detail";
import {mapGetters} from "vuex";
import {customerType} from '@/constants/posNovin'

export default {
    components: {
        'customer-detail': customerDetail,
    },
    data() {
        return {
            inquiry_form: {},
            show_detail: false,
            show_inquiry_form: true,
            customerType
        }
    },
    props: {
        wizard: {
            type: Object
        },
        form_data: {
            type: Object
        }
    },
    methods: {
        getCustomer() {
            let form = $('#get_customer_by_code')
            let btn = $('#submit_btn')
            this.show_detail = false
            form.validate({
                lang: 'fa',
                rules: {
                    customer_type_id: {
                        required: true
                    },
                    national_code: {
                        required: () => {
                            if (this.inquiry_form.customer_type_id == customerType.REAL ||
                                    this.inquiry_form.customer_type_id == customerType.MULTI_ACCOUNT_OWNER) return true;
                        },
                        digits: true,
                        minlength: 10,
                        maxlength: 10
                    },
                    company_code: {
                        required: () => {
                            if (this.inquiry_form.customer_type_id == customerType.LEGAL) return true;
                        },
                        digits: true,
                        minlength: 11,
                        maxlength: 11
                    },
                }
            });
            if (!form.valid()) {
                return
            }
            this.is_foreign = false
            KTApp.progress(btn)
            this.$store.commit('pos/clearFormData')
            this.inquiry_form.psp = this.psp
            posService.getCustomerByCode(this.inquiry_form).then(response => {
                if (response.data.data) {
                    this.form_data.customer_detail = response.data.data
                    if (!this.$can('manage', 'pos')) {
                        this.$store.commit('pos/canChange', false)
                    } else this.$store.commit('pos/canChange', true)

                    this.showMsg(form, 'success', response.data.message)
                } else {
                    this.$store.commit('pos/canChange', true)
                    this.form_data.customer_detail.is_foreign_nationals = false
                    this.form_data.customer_detail.customer_type_id = this.inquiry_form.customer_type_id
                    if (this.inquiry_form.customer_type_id == customerType.REAL||
                            this.inquiry_form.customer_type_id == customerType.MULTI_ACCOUNT_OWNER) {
                        this.form_data.customer_detail.national_code = this.inquiry_form.national_code
                    } else this.form_data.customer_detail.company_code = this.inquiry_form.company_code
                    this.showMsg(form, 'danger', response.data.message)
                }
                this.show_inquiry_form = false
                this.show_detail = true
                this.afterDispatch()
                this.wizard.newCustomer = true
            })
                    .catch(({response}) => {
                        // this.showMsg(form, 'danger', response.data.message)
                        let message = document.createElement('div')
                        message.innerHTML = response.data.message
                        Object.keys(response.data.data).forEach(function (item) {
                            var li = document.createElement('li')
                            li.innerText = response.data.data[item][0]
                            message.insertAdjacentElement('beforeend', li)
                        })
                        this.showMsg(form, 'danger', message)
                    })
                    .finally(() => {
                        KTApp.unprogress(btn)
                    })
        },
        afterDispatch() {
            setTimeout(
                    $('.kt-selectpicker').selectpicker({
                        size: 6,
                        liveSearch: false,
                        noneResultsText: i18n.t('selectpicker.none_result'),
                        selectAllText: i18n.t('selectpicker.select_all'),
                        noneSelectedText: i18n.t('selectpicker.nothing_chose')

                    }), 500)
        }
    },
    computed: {
        ...mapGetters('pos', [
            'constants', 'can_change', 'psp'
        ])
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.afterDispatch()
        })
    },
    mounted() {
        this.afterDispatch();
        if (window.localStorage.getItem('go') === '2') {
            window.localStorage.setItem('go', 'change');
            this.wizard.current_step = 2;
        }
    },
}
</script>

<style>
.kt-form-label {
    text-align: right !important;
}

.label-file {
    border: 1px solid #ccc;
    width: fit-content;
    cursor: pointer;
    min-width: 200px;
}

input[type=number]::-webkit-inner-spin-button {
    -webkit-appearance: none;
}
</style>